import http from '../helpers/http';

const Discounts = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async () => {
      const result = await http.get(`/discounts`, {
        headers,
      });
      return result.data;
    },
    create: async (body: { name: string; percentage: number }) => {
      const result = await http.post(`/discounts`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/discounts/${id}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default Discounts;
